module.exports = __webpack_public_path__ + "static/media/stride_logo.d52bf859.png";